import { useState } from 'react'
import { Link } from 'react-router-dom'
import { ArrowLeft, ChevronDown, Mail, MessageCircle, BookOpen } from 'lucide-react'

const faqs = [
  {
    question: 'Бүртгэл хэрхэн үүсгэх вэ?',
    answer:
      'Та манай вэб хуудасны баруун дээд буланд байрлах "Бүртгүүлэх" товчлуур дарж, утасны дугаар болон шаардлагатай мэдээллээ оруулан бүртгэлээ үүсгэнэ үү.',
  },
  {
    question: 'Сургалтанд хэрхэн бүртгүүлэх вэ?',
    answer:
      'Хүссэн сургалтаа сонгоод "Бүртгүүлэх" товч дарна. Төлбөртэй сургалтын хувьд төлбөрөө төлсний дараа хичээлүүд нээгдэнэ.',
  },
  {
    question: 'Premium гишүүнчлэл гэж юу вэ?',
    answer:
      'Premium гишүүнчлэлтэй бол та манай платформ дээрх бүх сургалт, видео контентыг хязгааргүй үзэх боломжтой болно.',
  },
  {
    question: 'Төлбөрөө хэрхэн төлөх вэ?',
    answer:
      'Бид QPay, банкны шилжүүлэг зэрэг төлбөрийн сувгуудыг дэмждэг. Сургалт эсвэл гишүүнчлэл сонгоход төлбөрийн сонголтууд гарч ирнэ.',
  },
  {
    question: 'Сургалтын видеог татаж авч болох уу?',
    answer:
      'Одоогоор видео татах боломжгүй. Гэхдээ та интернэт холболттой үедээ хүссэн үедээ үзэх боломжтой.',
  },
  {
    question: 'Нууц үгээ мартсан бол яах вэ?',
    answer:
      'Нэвтрэх хуудасны "Нууц үг мартсан" холбоосоор орж, бүртгэлтэй утасны дугаараа оруулан шинэ нууц үг тохируулна уу.',
  },
]

const categories = [
  {
    icon: BookOpen,
    title: 'Сургалт',
    description: 'Сургалтанд бүртгүүлэх, үзэх, гэрчилгээ авах',
    link: '/courses',
  },
  {
    icon: MessageCircle,
    title: 'Багш нар',
    description: 'Пост нийтлэх, сэтгэгдэл, дагах',
    link: '/teachers',
  },
  {
    icon: Mail,
    title: 'Холбоо барих',
    description: 'Шууд бидэнтэй холбогдох',
    link: '/contact',
  },
]

export default function Help() {
  const [openFaq, setOpenFaq] = useState<number | null>(null)

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white border-b border-gray-200 py-4">
        <div className="max-w-[1024px] mx-auto px-4">
          <Link
            to="/"
            className="inline-flex items-center gap-2.5 text-sm font-medium text-gray-800 bg-white border border-gray-200 rounded-full px-4 py-2.5 shadow-md hover:bg-gray-50 transition"
          >
            <ArrowLeft className="size-5" />
            Буцах
          </Link>
        </div>
      </div>

      {/* Title */}
      <div className="text-center pt-8 pb-6">
        <h1 className="text-3xl md:text-5xl font-bold text-gray-800">ТУСЛАМЖ</h1>
        <p className="text-base text-gray-500 mt-3 max-w-[500px] mx-auto">
          Танд хэрэгтэй мэдээлэл, түгээмэл асуулт хариултууд энд байна.
        </p>
      </div>

      {/* Categories */}
      <div className="max-w-[1024px] mx-auto px-4 pb-10">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.title}
              to={cat.link}
              className="bg-white border border-gray-200 rounded-2xl p-6 flex flex-col gap-3 hover:border-gray-300 hover:shadow-sm transition"
            >
              <div className="size-10 rounded-xl bg-primary-50 flex items-center justify-center">
                <cat.icon className="size-5 text-primary-500" />
              </div>
              <p className="font-semibold text-gray-800">{cat.title}</p>
              <p className="text-sm text-gray-500">{cat.description}</p>
            </Link>
          ))}
        </div>
      </div>

      {/* FAQ */}
      <div className="max-w-[1024px] mx-auto px-4 pb-20">
        <h2 className="text-2xl font-bold text-gray-800 mb-6">Түгээмэл асуултууд</h2>
        <div className="flex flex-col gap-3">
          {faqs.map((faq, i) => (
            <button
              key={i}
              onClick={() => setOpenFaq(openFaq === i ? null : i)}
              className="bg-white rounded-2xl border border-gray-200 p-5 flex gap-4 items-start w-full text-left cursor-pointer hover:border-gray-300 transition"
            >
              <div className="flex-1">
                <p className="text-base font-medium text-gray-800">{faq.question}</p>
                {openFaq === i && (
                  <p className="text-sm text-gray-500 mt-3 leading-relaxed">{faq.answer}</p>
                )}
              </div>
              <ChevronDown
                className={`size-5 text-gray-400 shrink-0 mt-0.5 transition-transform ${openFaq === i ? 'rotate-180' : ''}`}
              />
            </button>
          ))}
        </div>
      </div>
    </div>
  )
}
